import React, { Component } from "react";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import successCar from "../../assets/images/animations/Succes.json";
import errorCar from "../../assets/images/animations/Error.json";
import { mailIcon } from "../../common/utils/images";
import LoanConfirmationDetail from "../../common/components/pageBlocks/confirmation/loanConfirmationDetail";
import FormStep from "../../common/components/formStep";
import LottieAnimation from "../../common/components/lottieAnimation";
import commonContext, { AppContext } from "../../common/context/common";
// import { Zd10SecApis } from "../apis/zd10SecApis";
import { leadType } from "../../app";
import { Qm10SecApis } from "../apis/qm10SecApis";
import { Utilities } from "../../common/utils/utilities";

interface IProps {
    history: any;
}
interface IState {
    status: boolean;
    applicationNumber: string;
    carModel: string;
}
class Confirmation extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    apis: Qm10SecApis;
    setLead: Function;
    utils: Utilities;
    steps = [
        { title: "Vehicle" },
        { title: "Loan" },
        { title: "Review" },
        { title: "Personal" },
    ];
    constructor(props: IProps) {
        super(props);
        this.state = {
            status: true,
            applicationNumber: "",
            carModel: "Maruti Baleno",
        };
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.apis = (this.context as AppContext).apis as Qm10SecApis;
        this.setLead = (this.context as AppContext).setLead;
        this.lead = (this.context as AppContext).lead as leadType;
        const apiData = await this.apis.successDetails(this.lead);
        if (
            this.context?.lead?.modelDescription &&
            this.context?.lead?.uniqueReferenceNo
        ) {
            this.setState({
                carModel: this.context.lead.modelDescription,
                applicationNumber: this.context.lead.uniqueReferenceNo,
            });
        }
        this.setLead(apiData.result);
    }
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.utils = (this.context as AppContext).utils as Utilities;
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="confirm-wrap mt-110">
                        <div className="container mx-auto px-5">
                            <FormStep
                                steps={[
                                    ...this.steps,
                                    {
                                        title: "Confirmation",
                                        active: true,
                                        failed: !this.lead.confirmStatus,
                                    },
                                ]}
                            />

                            <div className="congrats-screen w-full">
                                <div className="flex justify-center mx-auto car-img-wrap mb-3 md:mb-6">
                                    <LottieAnimation
                                        width={230}
                                        height={180}
                                        animationData={
                                            this.lead.confirmStatus
                                                ? successCar
                                                : errorCar
                                        }
                                    />
                                </div>
                                {this.lead.confirmStatus ? (
                                    <>
                                        <h1 className="text-center text-gray-2 font-42px openSans-Light mt-3 w-10/12 mx-auto">
                                            Congratulations
                                        </h1>
                                        <h2 className="text-center text-gray-2 text-base md:text-2xl openSans-Light my-3 w-10/12 mx-auto">
                                            Your CarNCash (Car Loan Topup) of{" "}
                                            <span className="openSans-SemiBold bigg">
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>{" "}
                                                {this.utils.currencyFormat(
                                                    this.lead.totalAmount
                                                )}
                                                /-{" "}
                                            </span>{" "}
                                            has been disbursed in 10 seconds.
                                            After deduction of applicable
                                            charges, the net amount of for{" "}
                                            <span className="openSans-SemiBold bigg">
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>{" "}
                                                {this.utils.currencyFormat(
                                                    this.lead.totalAmount
                                                )}
                                                /-{" "}
                                            </span>{" "}
                                            has been credited to your bank
                                            account no{" "}
                                            <span className="openSans-SemiBold bigg">
                                                XXXXXXXXX
                                                {((this.lead
                                                    .bankAccount as unknown) as string).substr(
                                                    ((this.lead
                                                        .bankAccount as unknown) as string)
                                                        .length - 4
                                                )}
                                            </span>{" "}
                                            Jab Bhi Chaho Loan Pao
                                        </h2>
                                    </>
                                ) : (
                                    <>
                                        <h1 className="text-center text-gray-2 font-42px openSans-Light mt-3 w-full md:w-8/12 mx-auto">
                                            There seems to be an issue with your
                                            CarNCash (Car Loan Topup)
                                        </h1>

                                        <p className="openSans-SemiBold bigg text-center text-base sm:text-xl md:text-2xl">
                                            Lorem ipsum dolor sit amet,
                                            consectetur ading elit,
                                        </p>
                                    </>
                                )}
                            </div>
                        </div>
                    </section>
                </div>
            </>
        );
    }
}

export default Confirmation;
